import { render, staticRenderFns } from "./threshold_durationColumn.vue?vue&type=template&id=1886b62b&scoped=true&"
import script from "./threshold_durationColumn.vue?vue&type=script&lang=js&"
export * from "./threshold_durationColumn.vue?vue&type=script&lang=js&"
import style0 from "./threshold_durationColumn.vue?vue&type=style&index=0&id=1886b62b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886b62b",
  null
  
)

export default component.exports